/**
 * This is the main js source file. It is used for theme development.
 * The theme is configured to use Webpack to output a single minified js file for production
 * The actual compiled js file is located in build/js folder
 */
import combineMenusOnMobile from './components/combine-menus.js';
import navigation from './components/navigation.js';
import themeOptions from './settings/theme-options.js';
import { spinner } from './general/spinner.js';
import masonryLayout from './components/masonry.js';
import { wrapButtons } from './components/buttons.js';
import { heroPattern } from './components/patterns/hero.js';
import servicesDarkMode from './components/patterns/services.js';
import { runStatsCounter } from './components/patterns/stats-counter.js';

( function() {
	navigation();
	themeOptions();
	spinner();
	combineMenusOnMobile();
	masonryLayout();
	wrapButtons();
	heroPattern();
	servicesDarkMode();
	runStatsCounter();
}() );
